import type { KanbanBlock as KanbanBlockType } from "../../types";
import type { BlockProps } from "blocks/v2/__shared__/types";
import { KanbanHeader } from "./KanbanHeader";
import { TableBackedKanban } from "./TableBackedKanban";

const KANBAN_SKELETON_DATA = [
  {
    id: "1",
    label: "Card 1",
    cards: [
      {
        id: "card1",
        descriptionFieldType: "text",
        description: "Description",
        title: "Card 1",
      },
      {
        id: "card2",
        descriptionFieldType: "text",
        description: "Description",
        title: "Card 2",
      },
    ],
  },
  {
    id: "2",
    label: "Card 2",
    cards: [
      {
        id: "card1",
        descriptionFieldType: "text",
        description: "Description",
        title: "Card 1",
      },
    ],
  },
  {
    id: "3",
    label: "Card 3",
    cards: [],
  },
];

export default function KanbanSkeleton({ block }: BlockProps<KanbanBlockType>) {
  return (
    <>
      <KanbanHeader title={block.config.title} />
      <TableBackedKanban data={KANBAN_SKELETON_DATA} isSkeleton />
    </>
  );
}
